export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8689.04f4ee72.jpg";